import * as React from "react";

export function withStoryContainer(story: any) {
    return <div className="story-container">{story()}</div>;
}
